import { useNavigate } from 'react-router-dom';

import { store } from '../../../configureStore';
import orm from '../../../orm';
import { appShowWebNavigationBarSelector } from '../../app/selectors';
import NavBarComponent from '../../navNode/NavBarComponent';

type Props = {
  // navigation: any;
  navNodeId: string;
};

const DEBUG = false;
const debugLog = (msg: string) => {
  if (DEBUG) {
    console.log(msg);
  }
};

const PdfFileComponent = (props: Props) => {
  // const PdfFileComponent = (props: PdfFileComponentScreenProps) => {
  debugLog('Component: PdfFileComponent with props: ' + JSON.stringify(props, null, 4));

  const navigate = useNavigate();

  const { navNodeId } = props;

  const session = orm.session(store.getState().orm);
  const { Experience, NavNode, PdfFile } = session;
  // @ts-ignore
  const navNode = NavNode.withId(navNodeId);
  const contentId = navNode.contentId;
  const experienceId = navNode.experienceId;
  // @ts-ignore
  const experience = Experience.withId(experienceId);

  // @ts-ignore
  const pdfFile = PdfFile.withId(contentId);
  const pdfFilePath = pdfFile.pdfFilePath;

  debugLog('PdfFileComponent - experienceId : ' + experienceId);
  debugLog('PdfFileComponent - experience : ' + JSON.stringify(experience, null, 2));
  debugLog('PdfFileComponent - navNodeId : ' + navNodeId);
  debugLog('PdfFileComponent - navNode: ' + JSON.stringify(navNode, null, 2));
  debugLog('PdfFileComponent - contentId : ' + contentId);
  debugLog('PdfFileComponent - pdfFile : ' + JSON.stringify(pdfFile, null, 2));

  const goBack = () => {
    if (navNode.parentId === null) {
      navigate(`/`);
    } else {
      navigate(`${process.env.REACT_APP_BASENAME}#nn=${navNode.parentId}`);
    }
  };

  const externalUrlToPdfFile = `${process.env.REACT_APP_EXPERIENCE_CONTENT_BASE_URL}${experienceId}/${pdfFile.pdfFilePath}`;
  debugLog('externalUrlToPdfFile : ' + externalUrlToPdfFile);
  
  const showWebNavigationBar = appShowWebNavigationBarSelector(store.getState());

  return (

    // <div>
    //   <div>
    //     <object
    //       type={'application/pdf'}
    //       data={externalUrlToPdfFile}
    //       width={window.innerWidth}
    //       height={window.innerHeight}
    //     ></object>
    //   </div>
    //   <p>Below a PDF file</p>
    // </div>
    
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: window.innerHeight,
      width: window.innerWidth,
      // border: '1px solid red',
    }}>

      <div style={{
        flexGrow: 0,
        // border: '1px solid green',
      }}>
      { showWebNavigationBar &&
        <NavBarComponent navNodeId={navNodeId} showBrandNameSettings={false} showGoBack={false} showSettings={false} showSharing={false} title={''} />
      }
      </div>

      <iframe
        id="iFrameExample"
        title="iFrame Example"
        src={`${externalUrlToPdfFile}`}
        width={window.innerWidth}
        style={{
          flexGrow: 1,
        }}
      >
      </iframe>

    </div>


  );
};
// <Pdf source={source} style={[layout.pdf, {width, height}]} fitPolicy={0} />

export default PdfFileComponent;
